<template>
  <AtomLink
    v-if="title && url"
    :url="url"
    class="flex sm:flex-col w-full p-2 sm:p-4 rounded-2xl lg:rounded-3xl group shadow-md hover:shadow-none transition duration-200 cursor-pointer"
    :class="backgroundColor"
    data-component="Cardoverview"
  >
    <div class="flex flex-col flex-auto py-2 sm:py-0 sm:pr-6 order-2">
      <h4 class="order-2 sm:text-xl md:text-2xl text-app-primary-1-red--fire-brick leading-tight font-semibold sm:font-medium mb-1 sm:mb-2">
        {{ title }}
      </h4>
      <h5 v-if="subtitle" class="order-1 text-sm md:text-base leading-tight font-medium mb-2">{{ subtitle }}</h5>
      <AtomIconArrowRight
        class="order-3 hidden sm:block mt-auto ml-auto sm:-mr-5 md:-mr-4 md:mb-2 w-4 h-4 sm:w-6 sm:h-6 text-app-primary-1-red--fire-brick group-hover:translate-x-1 transform transition duration-200"
      />
    </div>
    <div class="relative overflow-hidden rounded-xl lg:rounded-2xl sm:mb-6 mr-3 sm:mr-0 w-20 h-20 sm:w-full sm:h-auto shrink-0 order-1">
      <MoleculePicture v-if="image" class="w-full h-full transition duration-1000 group-hover:scale-105 shrink sm:shrink-1 block" :image="image" :aria-hidden="true" />

      <!-- Fallback images for this specific component -->
      <img v-if="!image" src="/images/fallback/314x242.png" :alt="title" class="w-full h-full transition duration-1000 group-hover:scale-105 hidden sm:block" />
      <img v-if="!image" src="/images/fallback/80x80.png" :alt="title" class="w-full h-full transition duration-1000 group-hover:scale-105 shrink-0 sm:hidden" />
      <div
        v-if="icon"
        class="absolute z-10 bottom-0 left-0 sm:bottom-auto sm:left-auto sm:top-0 sm:right-0 rounded-tr-xl sm:rounded-tr-none sm:rounded-bl-3xl flex items-center justify-center w-8 sm:w-12 h-8 sm:h-12"
        :class="backgroundColor"
      >
        <AtomIcon :icon="icon" classes="w-5 sm:w-6 text-app-primary-1-red--fire-brick" />
      </div>
    </div>
    <div class="sm:hidden flex shrink-0 items-end pr-1 ml-2 ml-auto order-3">
      <AtomIconArrowRight class="w-4 h-4 sm:w-6 sm:h-6 text-app-primary-1-red--fire-brick group-hover:translate-x-1 transform transition duration-200" />
    </div>
  </AtomLink>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, required: false, default: undefined },
  image: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  url: { type: String, required: true },
  backgroundColor: { type: String, required: false, default: 'bg-white' },
  icon: { type: String, required: false, default: undefined },
})
</script>
